import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faPlus, faTimes, faBan } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import './Register.css'
import { fetchUsuario, getUsuario } from '../../user';
import Swal from 'sweetalert2';
import Helper from '../../../Helpers/helpers';
import Switch from "react-switch";

export default function Register() {
    const [nombre, setNombre] = useState('');
    const [accessCode, setAccessCode] = useState('');
    const [email, setEmail] = useState('');
    const [telefono, setTelefono] = useState('+52-');
    const [rol, setRol] = useState(''); // Estado para el rol
    const [contrasena, setContrasena] = useState('');
    const [IdTienda, setIdTienda] = useState('');
    const [IdServicio, setIdServicio] = useState('');
    const [servicios, setServicios] = useState([]);
    const [mensaje, setMensaje] = useState('');
    const [mensaje2, setMensaje2] = useState('');
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [formularioEnviado, setFormularioEnviado] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [tiendasData, setTiendasData] = useState([]);
    const [estatus, setEstatus] = useState(true); // true = activo, false = inactivo

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const handleTelefonoChange = (e) => {
        const input = e.target.value;
        // Si el usuario está borrando, permitir borrar hasta el prefijo
        if (input.length < '+52-'.length) {
            setTelefono('+52-');
            return;
        }
        
        const formatted = Helper.formatPhoneNumber(input);
        setTelefono(formatted);
    };

    const crearCatalogo = async (e) => {
        e.preventDefault();
        
        // Validaciones de roles
        if ((rol === 'terapeuta' || rol === 'coord_programa') && !IdServicio) {
            toast.error('Debes seleccionar un programa para el rol de terapeuta o coord. programa');
            return;
        }
        
        if ((rol === 'coord_ceseco' || rol === 'direccion' || rol === 'coord_programa') && !IdTienda) {
            toast.error('Debes seleccionar un CESECO para este rol');
            return;
        }
        
        setMensaje2('Procesando...')
        try {
            const formData = new FormData();
            formData.append('nombre', nombre);
            formData.append('access_code', accessCode);
            formData.append('email', email);
            formData.append('rol', rol);
            formData.append('contrasena', contrasena);
            formData.append('IdTienda', IdTienda);
            formData.append('IdServicio', IdServicio);
            formData.append('telefono', Helper.cleanPhoneNumber(telefono));
            formData.append('estatus', estatus ? 'activo' : 'inactivo');

            const response = await fetch(`${baseURL}/registroPost.php`, {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                const data = await response.json();
                if (data.mensaje) {
                    setMensaje(data.mensaje);
                    toast.success(data.mensaje);
                    setMensaje2('')
                    setFormularioEnviado(false);
                    window.location.reload();

                } else if (data.error) {
                    setError(data.error);
                    toast.error(data.error);
                    setMensaje2('')

                }
            } else {
                throw new Error('Error en la solicitud al servidor');
            }
        } catch (error) {
            console.error('Error:', error.message);
            toast.error(error.message);
            setMensaje2('')
        }
    };

    //Trae usuario logueado-----------------------------
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);
    const usuarioLegued = getUsuario();
    const alertPermiso = () => {
        Swal.fire(
            '¡Error!',
            '¡No tienes permisos!',
            'error'
        );
    }

    useEffect(() => {
        cargarTiendas();
    }, []);

    const cargarTiendas = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTiendasData(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar cesecos:', error));
    };

    useEffect(() => {
        if ((rol === 'terapeuta' || rol === 'coord_programa') && IdTienda) {
            fetch(`${baseURL}/serviciosCategoriaGet.php?idTienda=${IdTienda}`, {
                method: 'GET',
            })
                .then(res => res.json())
                .then(data => {
                    setServicios(data.servicios);
                    setIdServicio('');
                })
                .catch(err => {
                    console.error('Error al cargar servicios:', err);
                    setServicios([]);
                });
        } else {
            setServicios([]);
            setIdServicio('');
        }
    }, [rol, IdTienda]);

    const modalContentStyle = {
        maxWidth: '760px',
        width: '90%',
        minWidth: '0',
        margin: '0 auto',
        boxSizing: 'border-box',
        padding: 0,
        border: 'none',
        borderRadius: '14px',
        overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)'
    };

    const modalHeaderStyle = {
        padding: '12px 20px',
        background: '#f7f9fb',
        borderBottom: '1px solid #e5e7eb',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    };

    const modalTitleStyle = {
        fontSize: '18px',
        fontWeight: 700,
        color: '#1f2937'
    };

    const modalFormStyle = {
        padding: '16px 20px 20px',
        background: '#fff'
    };

    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(220px, 1fr))',
        gap: '12px 16px'
    };

    const fieldsetStyle = {
        border: '1px solid #e5e7eb',
        borderRadius: '10px',
        padding: '10px 12px 12px',
        background: '#fafbfc'
    };

    const legendStyle = {
        fontSize: '12px',
        padding: '0 6px',
        color: '#6b7280',
        fontWeight: 600
    };

    const inputStyle = {
        width: '100%'
    };

    const buttonRowStyle = {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '12px',
        marginTop: '10px'
    };

    return (
        <div >
            <ToastContainer />
            {loading ? (
                <></>
            ) : usuarioLegued?.idUsuario ? (
                <>
                    {(usuarioLegued?.rol === 'admin' || usuarioLegued?.rol === 'direccion' || usuarioLegued?.rol === 'coord_ceseco') ? (
                        <button onClick={toggleModal} className='btnSave'>
                            <span>  +</span>   Agregar
                        </button>
                    ) : usuarioLegued?.rol === 'colaborador' ? (
                        <button onClick={alertPermiso} className='btnSave'>
                            <span>  +</span>   Agregar
                        </button>
                    ) : (
                        <></>
                    )}
                </>
            ) : (
                <button onClick={toggleModal} className='btnSave'>
                    <span>  +</span>   Agregar
                </button>
            )}

            {modalOpen && (
                <div className="modal" onClick={(e) => {
                    if (e.target.className === 'modal') {
                        toggleModal();
                    }
                }}>
                    <div
                        className="modal-content modal-content--register"
                        style={modalContentStyle}
                    >
                        <div className="modal-header" style={modalHeaderStyle}>
                            <span className="modal-title" style={modalTitleStyle}>Agregar Usuario</span>
                            <button className="modal-close" onClick={toggleModal} aria-label="Cerrar">
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <form onSubmit={crearCatalogo} id='crearForm' className="modal-form" autoComplete="off" style={modalFormStyle}>
                            <div className='flexGrap' style={gridStyle}>
                                <fieldset style={fieldsetStyle}>
                                    <legend style={legendStyle}>Nombre</legend>
                                    <input
                                        type="text"
                                        id="nombre"
                                        name="nombre"
                                        value={nombre}
                                        onChange={(e) => setNombre(e.target.value)}
                                        required
                                        placeholder="Nombre"
                                        style={inputStyle}
                                    />
                                </fieldset>
                                <fieldset style={fieldsetStyle}>
                                    <legend style={legendStyle}>No. Empleado/Estudiante</legend>
                                    <input
                                        type="text"
                                        id="access_code"
                                        name="access_code"
                                        value={accessCode}
                                        onChange={(e) => setAccessCode(e.target.value)}
                                        required
                                        placeholder="000123"
                                        style={inputStyle}
                                    />
                                </fieldset>
                                <fieldset style={fieldsetStyle}>
                                    <legend style={legendStyle}>Email</legend>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Email"
                                        style={inputStyle}
                                    />
                                </fieldset>
                                <fieldset style={fieldsetStyle}>
                                    <legend style={legendStyle}>Teléfono</legend>
                                    <input
                                        type="text"
                                        id="telefono"
                                        name="telefono"
                                        value={telefono}
                                        onChange={handleTelefonoChange}
                                        placeholder="Teléfono"
                                        required
                                        style={inputStyle}
                                    />
                                </fieldset>
                                <fieldset style={fieldsetStyle}>
                                    <legend style={legendStyle}>Rol</legend>
                                    <select
                                        id="rol"
                                        name="rol"
                                        value={rol}
                                        onChange={(e) => setRol(e.target.value)}
                                        required
                                        style={inputStyle}
                                    >
                                        <option value="">Seleccione un rol</option>
                                        <option value="secretaria">Secretaria</option>
                                        <option value="terapeuta">Terapeuta</option>
                                        <option value="coord_programa">Coord. programa</option>
                                        <option value="coord_ceseco">Coord. CESECO</option>
                                        <option value="direccion">Dirección</option>
                                        <option value="admin">Admin</option>
                                    </select>
                                </fieldset>
                                <fieldset style={fieldsetStyle}>
                                    <legend style={legendStyle}>Ceseco</legend>
                                    <select
                                        id="IdTienda"
                                        name="IdTienda"
                                        value={IdTienda}
                                        onChange={(e) => setIdTienda(e.target.value)}
                                        required
                                        style={inputStyle}
                                    >
                                        <option value="">Seleccione un ceseco</option>
                                        {
                                            tiendasData.length > 0 && tiendasData.map(tienda => (<option value={tienda.idCategoria}>{tienda.categoria}</option>))
                                        }
                                    </select>
                                </fieldset>
                                {(rol === 'terapeuta' || rol === 'coord_programa') && (
                                    <fieldset style={fieldsetStyle}>
                                        <legend style={legendStyle}>Programa</legend>
                                        <select
                                            id="IdServicio"
                                            name="IdServicio"
                                            value={IdServicio}
                                            onChange={(e) => setIdServicio(e.target.value)}
                                            required={rol === 'terapeuta' || rol === 'coord_programa'}
                                            style={inputStyle}
                                        >
                                            <option value="">Seleccione un programa</option>
                                            {servicios.map(p => (
                                                <option key={p.idServicio} value={p.idServicio}>{p.titulo}</option>
                                            ))}
                                        </select>
                                    </fieldset>
                                )}
                                <fieldset style={fieldsetStyle}>
                                    <legend style={legendStyle}>Contraseña</legend>
                                    <div className='deFlexPass'>
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            id="contrasena"
                                            name="contrasena"
                                            value={contrasena}
                                            onChange={(e) => setContrasena(e.target.value)}
                                            required
                                            placeholder="Contraseña"
                                            style={inputStyle}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                        </button>
                                    </div>
                                </fieldset>
                                <fieldset style={fieldsetStyle}>
                                    <legend style={legendStyle}>Estatus</legend>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                                        <Switch
                                            onChange={setEstatus}
                                            checked={estatus}
                                            onColor="#14A7A3"
                                            offColor="#ccc"
                                            checkedIcon={false}
                                            uncheckedIcon={false}
                                            height={22}
                                            width={44}
                                        />
                                        <span style={{fontWeight: 500, color: estatus ? '#14A7A3' : '#888'}}>
                                            {estatus ? 'Usuario Activo' : 'Usuario Inactivo'}
                                        </span>
                                    </div>
                                </fieldset>
                            </div>
                            <div className="modal-buttons" style={buttonRowStyle}>
                                {mensaje2 ? (
                                    <button type="button" className='btnLoading' disabled>
                                        {mensaje2}
                                    </button>
                                ) : (
                                    <>
                                        <button type="submit" className='btnPost'>
                                            <FontAwesomeIcon icon={faPlus} /> Agregar
                                        </button>
                                        <button type="button" className='btnCancel' onClick={toggleModal}>
                                            <FontAwesomeIcon icon={faBan} /> Cancelar
                                        </button>
                                    </>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
